<template>
  <div class="highscores-container">
    <h2>Nachhaltigkeits-Bestenliste</h2>
    <p>
      Dein Nachhaltigkeits-Score: {{ score }}
    </p>

    <div class="content">
      <div v-if="highscores.length < 1">
        <i class="fa fa-spinner fa-spin"/>
      </div>
      <div v-for="(s, i) in highscores" class="score" :class="{ own : s.score == score }" :key="s.rank">
        Platz {{ i + 1 }} : {{ s.score }}
      </div>
    </div>
  </div>
</template>

<script>
import backendService from '@/services/backend-service.js'

const SCORE_KEY = 'think-green:score'

export default {
  name: 'Highscores',
  data() {
    return {
      score: null,
      rawScores: []
    }
  },
  async created() {
    // this.score = JSON.parse(localStorage.getItem(SCORE_KEY))
    this.score = 45 // FIXME:
    this.rawScores = await backendService.getHighscores()
  },
  methods: {
    name() {

    }
  },
  computed: {
    highscores() {
      return this.rawScores.slice(0, 10).sort((a, b) => a.score < b.score ? 1 : -1)
    },
    
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.highscores-container {
  height: 100%;
  padding: 30px;
  padding-top: 50px;
  text-align: left;
}

.score {
  font-size: 20px;
  font-weight: bold;
}

.own {
  color: rgb(36, 167, 36);
  text-decoration: underline;
}
</style>